module.exports = __webpack_public_path__ + "img/change-cords__icon.e23b5fef.svg";